import { Box, useTheme } from '@mui/material';
import { Button } from '../../../../shared/components/ui/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface ActionButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
}

export function ActionButtons({ onEdit, onDelete }: ActionButtonsProps) {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<EditIcon />}
        sx={{
          fontWeight: 700,
          fontSize: 16,
          borderRadius: 2,
          px: 3,
          py: 1,
          textTransform: 'none',
          bgcolor: theme.palette.mode === 'light' ? '#F0F6FF' : theme.palette.background.paper,
          borderColor: theme.palette.mode === 'light' ? '#B6D4FE' : theme.palette.divider,
          color: theme.palette.text.primary,
          '&:hover': {
            bgcolor: theme.palette.mode === 'light' ? '#E3EDFC' : theme.palette.action.hover,
            borderColor: theme.palette.mode === 'light' ? '#B6D4FE' : theme.palette.divider,
          },
        }}
        onClick={onEdit}
      >
        Editar Usuário
      </Button>
      {/* <Button
        variant="outlined"
        color="error"
        startIcon={<DeleteOutlineIcon />}
        sx={{ fontWeight: 700, fontSize: 16, borderRadius: 2, px: 3, py: 1, textTransform: 'none', bgcolor: '#FFF0F0', borderColor: '#F3D1D1', '&:hover': { bgcolor: '#FFE5E5', borderColor: '#F3D1D1' } }}
        onClick={onDelete}
      >
        Excluir Usuário
      </Button> */}
    </Box>
  );
}